import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface ProjectNavTarget {
  /** Open a specific project by id */
  projectId?: string;
  /** Find the project that owns this conversation (used for chat notifications) */
  conversationId?: string;
  /** Which project detail tab to open — defaults to 'details' */
  initialTab?: string;
  /** Optional invoice to open when landing on the invoicing tab */
  invoiceId?: string;
  /** Optional pending payment request to surface in the invoice view */
  pendingPaymentRequestId?: string;
}

interface ProjectNavigationState {
  pendingNavTarget: ProjectNavTarget | null;
}

const initialState: ProjectNavigationState = {
  pendingNavTarget: null,
};

const projectNavigationSlice = createSlice({
  name: 'projectNavigation',
  initialState,
  reducers: {
    setProjectNavTarget: (state, action: PayloadAction<ProjectNavTarget>) => {
      state.pendingNavTarget = action.payload;
    },
    clearProjectNavTarget: state => {
      state.pendingNavTarget = null;
    },
  },
});

export const { setProjectNavTarget, clearProjectNavTarget } = projectNavigationSlice.actions;
export default projectNavigationSlice.reducer;
